class DatatableCookiePaging {
    constructor() {
        $.extend(true, $.fn.dataTable.defaults, {
            pageLength: KTCookie.get("datatable_page_length") ? KTCookie.get("datatable_page_length") : 10,
            lengthMenu: [10, 25, 50, 100]
        });

        $(document).on('length.dt', function(e, settings, len) {
            const date = new Date(Date.now() + 180 * 24 * 60 * 60 * 1000); // 180 dní
            KTCookie.set("datatable_page_length", len, {expires: date});
        });
    }
}
window.DatatableCookiePaging = DatatableCookiePaging;